import { useMutation, useQueryClient } from "@tanstack/react-query";
import { motion, useReducedMotion } from "framer-motion";
import { api, formatApiError } from "../../api";
import { Switch } from "../ui/switch";
import { toast } from "../ui/sonner";
import { CONTROL } from "../../constants/testIds";
import { fadeUp } from "../../lib/motion";

const MODULE_LABELS = { payments: "Payments", retail: "Retail POS", expense: "Expense & Payouts", broadcast_os: "BroadcastOS" };

// UX-CP-01 §3 SCR-P08-13 "Module toggles — this write IS the enforcement point". Requires the
// 'provision' Kairoo permission (same permission that gates the Gyms nav item/list itself).
export function ModuleTogglesPanel({ orgId, entitlements, canEdit }) {
  const reducedMotion = useReducedMotion();
  const queryClient = useQueryClient();

  const toggleMutation = useMutation({
    mutationFn: ({ module, enabled }) => api.patch(`/control/gyms/${orgId}/entitlements/${module}`, { enabled }),
    onSuccess: (_res, { module, enabled }) => {
      toast.success(`${MODULE_LABELS[module] || module} ${enabled ? "enabled" : "disabled"}`);
      queryClient.invalidateQueries({ queryKey: ["control-gym-detail", orgId] });
    },
    onError: (e) => toast.error(formatApiError(e).message),
  });

  return (
    <motion.div {...fadeUp(reducedMotion)} className="solid-surface rounded-[14px] p-5 space-y-1">
      <p className="eyebrow mb-2">Modules</p>
      {Object.entries(MODULE_LABELS).map(([module, label]) => (
        <div key={module} className="flex items-center justify-between py-2.5 border-b last:border-0" style={{ borderColor: "var(--scarlet-hairline)" }}>
          <span className="text-sm font-medium" style={{ color: "var(--scarlet-text)" }}>{label}</span>
          <Switch
            data-testid={CONTROL.moduleToggle(module)}
            checked={!!entitlements?.[module]}
            disabled={!canEdit || toggleMutation.isPending}
            onCheckedChange={(checked) => toggleMutation.mutate({ module, enabled: checked })}
          />
        </div>
      ))}
      {!canEdit && <p className="text-xs mt-2" style={{ color: "var(--scarlet-text-secondary)" }}>Requires the 'provision' Kairoo permission to edit.</p>}
    </motion.div>
  );
}
